"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountry = void 0;
const locale_1 = require("./constants/locale");
const LocaleCountryMap = {
    [locale_1.Locale.nl_NL]: locale_1.Country.Netherlands,
    [locale_1.Locale.nl_BE]: locale_1.Country.Belgium,
};
/**
 * Get the country code from Locale string
 * or if no locale, bad locale provided just return 'NL" as a default value
 * @param locale locale string
 * @returns country code from Locale string or default country code as NL
 * @default 'NL'
 *
 * @example
 * getCountry('nl_NL')
 * //=> NL
 *
 * @example
 * getCountry('nl')
 * //=> 'NL'
 *
 * @example
 * getCountry('')
 * //=> 'NL'
 */
const getCountry = (locale) => {
    return LocaleCountryMap[locale || locale_1.DEFAULT_LOCALE];
};
exports.getCountry = getCountry;
